const routes = {
  root: '/company-specific-training/details',
}

export default routes
